/** The orders the search endpoint knows, newest first being its default. */
export enum CaseSortOrder {
  NewestFirst = 'newestFirst',
  OldestFirst = 'oldestFirst',
  LongestFirst = 'longestFirst',
  ShortestFirst = 'shortestFirst',
  TitleAsc = 'titleAsc',
}
